import { useEffect } from "react";
import Configurator from "@/pages/Configurator";

/**
 * Version iframe-embed du configurateur.
 *
 * Différences majeures avec /configurateur :
 * - Pas de navbar
 * - Container avec `overflow-y: auto` + hauteur fixe → crée un contexte de scroll
 *   INTERNE à l'iframe. Sans ça, `position: sticky` ne fonctionne pas dans un
 *   iframe qui grandit dynamiquement (car il n'y a plus d'ancêtre scrollable).
 * - Postmessage envoie une hauteur FIXE (viewport parent) au lieu du contenu
 *   complet — l'iframe garde sa taille écran, le scroll interne prend le relais.
 *   Le visualizer sticky reste alors visible tout au long du défilement.
 */
export default function Embed() {
  useEffect(() => {
    document.body.style.background = "#FDFBF7";
    document.documentElement.style.height = "100%";
    document.body.style.height = "100%";
    document.body.style.margin = "0";
    document.body.style.overflow = "hidden";  // Le scroll se fait dans #embed-scroll

    // On envoie au parent une hauteur cible = la taille viewport actuelle
    // (arrondie), pas la hauteur du contenu. L'iframe reste donc "fenêtrée"
    // et son scroll interne fait fonctionner le sticky visualizer.
    const post = () => {
      // Cible : min(hauteur écran user, 900px) — l'iframe reste toujours
      // suffisamment haute pour un usage confortable sans envahir la page WP.
      const target = Math.min(Math.max(window.innerHeight, 700), 1100);
      window.parent?.postMessage({ type: "aih-configurator-resize", height: target }, "*");
    };
    post();
    window.addEventListener("resize", post);
    // On post une fois de plus après montage pour que la valeur soit bien reçue
    const t = setTimeout(post, 500);
    return () => {
      window.removeEventListener("resize", post);
      clearTimeout(t);
    };
  }, []);

  return (
    <div
      id="embed-scroll"
      data-testid="embed-configurator"
      style={{ height: "100vh", overflowY: "auto", overflowX: "hidden", background: "#FDFBF7" }}
    >
      <Configurator embed />
    </div>
  );
}
